const statuses = [
  'PENDING',
  'CANCELLED',
  'INPROGRESS',
  'COMPLETED',
  'REJECTED',
  'STARTEXCHANGE',
  'ENDEXCHANGE',
];

const statusDetails = [
  { type: ['all'], value: 'NEEDSAPPROVAL' },
  { type: ['subscriptions'], value: 'MARKASRETURNED' },
  { type: ['subscriptions'], value: 'MARKASDELIVERED' },
  { type: ['subscriptions'], value: 'SCHEDULEDELIVERY' },
];

const hideActions = ['CANCELLED', 'COMPLETED'];

export { statuses, hideActions, statusDetails };
